import React from 'react'
import { BiPhoneCall ,BiMailSend} from 'react-icons/bi'
import { GoLocation } from 'react-icons/go'
import { useTranslation } from 'react-i18next';
// import './i18n'; 

const Contact = () => {
    const { t, i18n } = useTranslation();

    return (
         
            <div className="contact container h-100">
                <form className="mt-5 pt-5 shadow">
                    <h3 className="border-bottom ml-3 border-warning w-50 text-capitalize">{t('contact information')}</h3>
                    <BiPhoneCall className="icon m-3 mt-3 h5" /> <strong className="h4"> +81 80 1356 4065 </strong> <br/>
                    <BiMailSend className="icon m-3 h5" /> 
                        <strong className="h4">SadeqiSoli@gmail.com </strong> <br/>
                    <GoLocation className="icon m-3 h5"  /> <strong className="h4"> {t('tokyo')}　、{t('japan')}</strong> <br/>
                </form>
            </div>
         
    )
}

export default Contact
